import Verify from './src/main'
export default {
  install(Vue, props) {
    Vue.prototype.$Verify = options => {
      Verify(options, props)
    }
  }
}
